// src/App.js
import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebase";
import "./App.css";

import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import MainContent from "./components/MainContent";
import Login from "./components/Login";

function App() {
  const [activePage, setActivePage] = useState("Dashboard");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  if (loading) {
    return (
      <div className="app-loader">
        <div className="loader-card">
          <div className="pulse-ring"></div>
          <h3>Aqua-Sense</h3>
          <p>Initializing dashboard…</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/dashboard"
        element={
          user ? (
            <div className="container">
              <Sidebar
                isCollapsed={isSidebarCollapsed}
                toggleSidebar={() =>
                  setIsSidebarCollapsed((prev) => !prev)
                }
                showContent={setActivePage}
                activePage={activePage}
              />
              <div
                className={`content-area ${
                  isSidebarCollapsed ? "sidebar-collapsed" : ""
                }`}
              >
                <Header activePage={activePage} />
                <MainContent activePage={activePage} />
              </div>
            </div>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      <Route
        path="/login"
        element={user ? <Navigate to="/dashboard" replace /> : <Login />}
      />

      <Route
        path="/"
        element={<Navigate to={user ? "/dashboard" : "/login"} replace />}
      />
    </Routes>
  );
}

export default App;